import { padSingleDecimal } from "./util";

export const toPriceString = (price: number) => {
    const formatter = new Intl.NumberFormat("th", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
    });

    return padSingleDecimal(formatter.format(price));
};